/**
 * Signální štítky z pravidel (spec 02 FR-1).
 *
 * Text i závažnost posílá backend (`SignalOut.label_cs`, `detail_cs`,
 * `severity`) — pravidla a prahy žijí tam, UI si je nevymýšlí. Tady se řeší
 * jen vzhled a to, že barva NIKDY nenese význam sama: vždy s popiskem
 * a s vysvětlením pravidla v tooltipu.
 */
import type { Signal, SignalCode } from '@/api/models';

/** Záložní popisky, kdyby backend `label_cs` neposlal. */
const FALLBACK_LABEL: Record<SignalCode, string> = {
  underperformer: 'Podvýkon',
  rising: 'Roste',
  falling: 'Klesá',
  low_fill: 'Nízký fill',
  stale_data: 'Zastaralá data',
};

/** Tón podle závažnosti ze SignalOut; `rising` je jediný pozitivní signál. */
function toneOf(signal: Signal): string {
  if (signal.code === 'rising') return 'good';
  if (signal.severity === 'critical') return 'critical';
  if (signal.severity === 'warning') return 'warning';
  return 'neutral';
}

export function SignalTagBadge({ signal }: { signal: Signal }) {
  return (
    <span className={`signal signal--${toneOf(signal)}`} title={signal.detail_cs}>
      <span className="signal__dot" aria-hidden="true" />
      {signal.label_cs || FALLBACK_LABEL[signal.code] || signal.code}
    </span>
  );
}

export function SignalTagList({ signals }: { signals: readonly Signal[] }) {
  if (signals.length === 0) return <span className="signal-list__empty">—</span>;
  return (
    <span className="signal-list">
      {signals.map((signal) => (
        <SignalTagBadge key={signal.code} signal={signal} />
      ))}
    </span>
  );
}
